import React from 'react'
import { Dialog, Button } from '@material-ui/core'
import DialogView from '../../../Dialogos/DialogView'
import { DialogConfirmacionContent } from '../../../Dialogos/DialogConfirmacionContent'
import { COLORES } from '../../../../config/colores'

function DialogoAlertaPeso (props) {
  const { closeAlerta, show, alerta } = props

  const rechazarCpe = () => {
    const motivo = (alerta === 'demora' ? 'LIDEMORA' : 'PESOLIMI')
    props.rechazarPesoBruto(motivo)
    closeAlerta()
  }

  const renderMensaje = () => {
    if (alerta === 'maximo') {
      return (
        <>
          <p>El peso supera el máximo permitido.</p>
          <p>Puede rechazar la carga o cerrar el diálogo y volver a leer. El peso máximo permitido solo se podrá modificar por un supervisor.</p>
        </>
      )
    } else if (alerta === 'advertencia') {
      return (
        <>
          <p>El peso supera el máximo de advertencia.</p>
          <p>Puede cerrar este dialogo y continuar pensando la carga o rechazarla.</p>
        </>
      )
    }
    //  else if (alerta === 'demora') {
    //   const fechaEgreso = moment(cea.fechaDeEgresoCalado).format('DD-MM-YYYY HH:mm')
    //   return (
    //     <>
    //       <p>El camión superó el tiempo promedio para trasladarse desde el calado a la balanza.</p>
    //       <p>Egreso de la playa de calado: <b>{fechaEgreso}</b></p>
    //       <p>Puede cerrar este dialogo y continuar pesando la carga o rechazarla.</p>
    //     </>
    //   )
    // }
  }

  return (
    <Dialog
      open={show}
      onClose={closeAlerta}
      maxWidth='sm'
    >
      <DialogView
        cancelCallback={closeAlerta}
        title='Atención'
        content={
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <DialogConfirmacionContent
              message={renderMensaje()}
            />

            <Button
              size='medium'
              style={{ margin: '2% auto', width: '48%', backgroundColor: COLORES.red.medium, color: '#ffffff' }}
              variant='contained'
              onClick={rechazarCpe}
            >
               Rechazar carga
            </Button>
          </div>
        }
      />

    </Dialog>
  )
}

export default DialogoAlertaPeso
